import { BrandsAttributionTable } from './brands-attribution-table';

export { BrandsAttributionTable };
